export const NOTIFICATIONS_ALL = 'ALL';
export const NOTIFICATIONS_NEW = 'NEW';
export const NOTIFICATIONS_ON_LOGIN = 'ON_LOGIN';

export const UPDATE_READ = 'READ';
export const UPDATE_SHOW = 'SHOW';
export const UPDATE_REMOVE = 'CLOSE';
